import { useCallback, useMemo } from "react";
import { debounce, throttle } from "lodash";

interface IUseTimingCallbackOptiosns {
    leadingFn?: ((..._: any[]) => void) | null;
    throttleFn?: ((..._: any[]) => void) | null;
    trailingFn?: ((..._: any[]) => void) | null;
}

export function useTimingCallbacks({
    leadingFn,
    throttleFn,
    trailingFn,
}: IUseTimingCallbackOptiosns) {
    const debouncedLeadingFn = useMemo(
        () =>
            leadingFn &&
            debounce(leadingFn, 500, { leading: true, trailing: false }),
        [leadingFn],
    );
    const throttleThrottleFn = useMemo(
        () => throttleFn && throttle(throttleFn, 300),
        [throttleFn],
    );
    const debouncedTrailingFn = useMemo(
        () =>
            trailingFn &&
            debounce(trailingFn, 500, { leading: false, trailing: true }),
        [trailingFn],
    );
    return useCallback(() => {
        debouncedLeadingFn?.();
        throttleThrottleFn?.();
        debouncedTrailingFn?.();
    }, [debouncedLeadingFn, throttleThrottleFn, debouncedTrailingFn]);
}
